import { baseApiRequest } from "../baseApiRequest"
const origin = process.env.REACT_APP_API_ORIGIN ?? ''

export async function unauthedQueryFunction<TResponse>(path: string) {
  const url = `${origin}/api/${path}`

  return baseApiRequest<TResponse>({
    url,
    init: {
      headers: {
        'Content-Type': 'application/json'
      },
    },
    trackingEvent: 'useUnauthedApiQuery',
  })
}
